<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 主要内容区域 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --invite">
          <div class="widjet__head">
            <h3 class="uk-text-lead">携手合作，共创未来</h3>
          </div>
          <div class="widjet__body">
            <div class="invite-section">
              <!-- 头部图片 -->
              <img src="@/assets/img/ss1726677487.png" alt="合作伙伴" class="header-img" />

              <!-- 合作伙伴邀请内容 -->
              <h2 class="section-title">🤝 期待你的加入</h2>
              <p class="description">
                <strong>您的建议对我们至关重要</strong><br />
                我们欢迎所有关于产品的反馈和建议，您的声音能帮助我们不断优化，打造更出色的体验。
              </p>

              <p class="description">
                <strong>成为合作伙伴</strong><br />
                我们希望将优质产品带给更多人。如果你认可我们的产品，欢迎加入我们，成为合作伙伴，共同推广，共享成长机会！
              </p>

              <!-- CTA 引导联系 -->
              <div class="cta">
                <p class="cta-text">📞 如有兴趣，请点击右下角客服与我们联系！</p>
                <a href="#" class="contact-btn">立即联系</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加信息 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">关于合作</h3>
          </div>
          <div class="widjet__body">
            <!-- 详细合作流程 -->
            <div class="section">
              <h2 class="section-title">📌 合作方式</h2>
              <ul class="list">
                <li>✅ 推广我们的产品，获取丰厚佣金</li>
                <li>✅ 享受专属合作伙伴优惠</li>
                <li>✅ 与我们一起打造更优质的服务</li>
              </ul>
            </div>

            <!-- 立即加入 -->
            <div class="section">
              <h2 class="section-title">🚀 立即加入</h2>
              <p class="faq-text">与我们携手，共享行业红利！</p>
              <a href="#" class="join-btn">成为合作伙伴</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "InvitationPage",
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 头部图片 */
.header-img {
  width: 100%;
  max-width: 700px;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
}

/* 🌟 标题样式 */
.section-title {
  font-size: 20px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-bottom: 10px;
}

/* 🌟 文字描述 */
.description {
  font-size: 18px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* 🌟 CTA 重点区域 */
.cta {
  background: #007bff;
  color: white;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}

.contact-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #ff5722;
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
}

.contact-btn:hover {
  background-color: #e64a19;
}

/* 🌟 右侧信息样式 */
.list {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.list li {
  font-size: 18px;
  color: #444;
  margin-bottom: 8px;
}

/* 🌟 立即加入 */
.join-btn {
  display: block;
  margin-top: 10px;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #28a745;
  text-decoration: none;
  border-radius: 5px;
  text-align: center;
  transition: background 0.3s;
}

.join-btn:hover {
  background-color: #218838;
}

/* 🌟 响应式优化 */
@media (max-width: 600px) {
  .widjet {
    padding: 15px;
  }

  .section-title {
    font-size: 18px;
  }

  .description {
    font-size: 16px;
  }

  .cta {
    font-size: 16px;
  }

  .contact-btn,
  .join-btn {
    font-size: 16px;
    padding: 8px 12px;
  }
}
</style>
